import React, { Component } from 'react'
import { Field } from 'redux-form'
import PlayerInput from './playerInput'

class PlayerInputMetadata extends Component {
  render() {
    const { source, ...rest } = this.props
    if (this.props.source) {
      return <Field {...rest} component={PlayerInput} name={source} />
    } else {
      return <PlayerInput {...this.props} />
    }
  }
}

export default PlayerInputMetadata
